import { Region } from './region.model'
import { Tag } from './tag.model'
import { Structure } from './structure.model'
import { Status } from "./status.model"
import { BudgetDiscipline } from './budget-discipline.model';
import { CalendarScope } from './calendar-scope.model'
import { Person } from './person.model'
import { FileTag } from './file-tag.model'
import { File } from './file.model';
import moment from 'moment'

export class Course {
    id: number;
    name: string;
    description: string;
    startDate: string;
    endDate: string;
    region: Region;
    structure: Structure;
    status: Status;
    budgetDiscipline: BudgetDiscipline;
    calendarScope: CalendarScope;
    olrReady: boolean;
    olcReady: boolean;
    useAdvancedOlr: boolean;
    attendEstimate: number;
    reportingContactHours: number;
    suppressCPDRecord: boolean
    accmeActivityID: string;
    reportingExclusion: boolean;
    contactPerson: Person;
    contactPhone: string;
    brochureUrl: string;
    internalComment: string;
    purposeGoals: string;
    topicKeywords: string;
    targetAudience: string;
    // trackSelectionRequired: boolean;
    // reportingHeadcount: number;
    // cipeEvent: boolean;
    // multiAhecEvent: boolean;
    // reportingCrosstabHeader: string;
    // parsSponsorship: string;
    registration: boolean;
    calendarReminder: string;
    image: File;
    tagRegions: Region[];
    tagStatewide: Tag[];
    showLmsOpen: boolean;
    joinUrl: string;
    landingPage: boolean;
    landingPageImage: File;
    welcomeMessage: string;
    slug: string;
    landingPageUrl: string;
    catalogUrl: string;

    constructor(data) {
        this.id =
            data.id != null || data.event_pk != null
                ? data.id != null
                    ? data.id
                    : data.event_pk
                : null;

        this.name =
            data.name || data.event_name
                ? data.name
                    ? data.name
                    : data.event_name
                : '';
        
        this.description =
            data.description || data.event_description
                ? data.description
                    ? data.description
                    : data.event_description
                : '';

        this.startDate =
            data.event_start_ts || data.start_date
                ? moment(
                      data.event_start_ts
                          ? data.event_start_ts
                          : data.start_date
                  ).format('MM/DD/YYYY hh:mm:ss A')
                : '';

        this.endDate =
            data.event_end_ts || data.end_date
                ? moment(
                      data.event_end_ts ? data.event_end_ts : data.end_date
                  ).format('MM/DD/YYYY hh:mm:ss A')
                : '';

        this.region = data.casce_ahec
            ? new Region(data.casce_ahec)
            : new Region({});

        this.structure = data.casce_event_structure
            ? new Structure(data.casce_event_structure)
            : new Structure({});

        this.status = data.casce_event_status
            ? new Status(data.casce_event_status)
            : new Status({});

        this.budgetDiscipline = data.casce_budget_discipline
            ? new BudgetDiscipline(data.casce_budget_discipline)
            : new BudgetDiscipline({});

        this.calendarScope = data.casce_event_calendar_scope
            ? new CalendarScope(data.casce_event_calendar_scope)
            : new CalendarScope({});

        this.olrReady = data.olr_ready != null ? data.olr_ready === 'Y' : false;

        this.olcReady = data.olc_ready != null ? data.olc_ready === 'Y' : false;

        this.useAdvancedOlr =
            data.use_advanced_olr != null ? data.use_advanced_olr === 1 : false;

        this.attendEstimate =
            data.attend_estimate != null ? data.attend_estimate : 0;

        this.reportingContactHours =
            data.reporting_contact_hours != null
                ? data.reporting_contact_hours
                : 0;
        
        this.accmeActivityID =
            data.casce_accme_activity_id != null
                ? data.casce_accme_activity_id.value
                : '';

        this.reportingExclusion =
            data.reporting_exclusion != null
                ? data.reporting_exclusion === 1
                : false;

        this.suppressCPDRecord =
            (data.suppress_cpd != null && data.suppress_cpd === 1) ? true : false;

        this.contactPerson = data.casce_contact_person
            ? new Person(data.casce_contact_person)
            : new Person({});

        this.contactPhone = data.contact_phone ? data.contact_phone : '';

        this.brochureUrl = data.brochure_url ? data.brochure_url : '';

        this.internalComment = data.internal_comment
            ? data.internal_comment
            : '';

        this.purposeGoals = data.purpose_goals ? data.purpose_goals : '';

        this.topicKeywords = data.topic_keywords ? data.topic_keywords : '';

        this.targetAudience = data.target_audience ? data.target_audience : '';

        // this.trackSelectionRequired = data.track_selection_required
        //     ? data.track_selection_required === 1
        //     : null;

        // this.reportingHeadcount =
        //     data.reporting_headcount != null ? data.reporting_headcount : null;

        // this.cipeEvent = data.cipe_event ? data.cipe_event === 1 : null;

        // this.multiAhecEvent = data.multi_ahec_event
        //     ? data.multi_ahec_event === 1
        //     : null;

        // this.reportingCrosstabHeader = data.reportingCrosstabHeader
        //     ? data.reportingCrosstabHeader
        //     : null;

        // this.parsSponsorship = data.pars_sponsorship
        //     ? data.pars_sponsorship
        //     : null;

        this.registration =
            (data.registration != null && data.registration == 1) ? true : false;

        this.calendarReminder = data.calendarReminder ? data.calendarReminder : null;

        let imageTag =
            data.file_tag && data.file_tag.length > 0
                ? new FileTag(data.file_tag[0])
                : null;

        this.image = imageTag ? imageTag.file : null;

        this.tagRegions = data.casce_event_tags_region
            ? data.casce_event_tags_region.map((tag) => new Region(tag))
            : [];

        this.tagStatewide = data.casce_event_tags_statewide
            ? data.casce_event_tags_statewide.map((tag) => new Tag(tag))
            : [];

        this.showLmsOpen =
            data.show_lms_open != null ? data.show_lms_open : false;

        this.joinUrl = data.casce_join_url ? data.casce_join_url.value : null;

        this.landingPage = (data.casce_landing_page && data.casce_landing_page.value === 1) ? true : false;

        let landingPageImageTag = data.landing_page_file_tag && data.landing_page_file_tag.length > 0 ? new FileTag(data.landing_page_file_tag[0]) : null;

        this.landingPageImage = landingPageImageTag ? landingPageImageTag.file : null;

        this.welcomeMessage = data.casce_welcome_message ? data.casce_welcome_message.value : null;

        if(this.id && this.name) {
            this.slug = this.name.trim().toLowerCase().replace(/\s/g,'-').replace(/[^a-zA-Z0-9 -]/g,'').substring(0, 200);

            this.catalogUrl = `/courses-and-events/${this.id}/${this.slug}`;

            this.landingPageUrl = `${this.catalogUrl}/event`;
        }
    }
}